export const toFixedWithLocale = (number: number): string => {
    return number.toLocaleString(undefined, {
        maximumFractionDigits: 2,
        minimumFractionDigits: 2
    });
}
